import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 13l-5 -10l-5 10m6 0l4 8l4 -8","key":"svg-0"}]]

/**
 * IconBrandStrava
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtc3RyYXZhIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSAxM2wtNSAtMTBsLTUgMTBtNiAwbDQgOGw0IC04IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-strava
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandStrava = createReactComponent('outline', 'brand-strava', 'BrandStrava', __iconNode);

export default IconBrandStrava;